import { registerPlugin, type PluginListenerHandle } from "@capacitor/core";

export interface JuspayInitiatePayload {
  requestId: string;
  service: string;
  payload: Record<string, unknown>;
}

export interface JuspayProcessPayload {
  requestId: string;
  service: string;
  payload: Record<string, unknown>;
}

export type JuspayEventData =
  | { event: "initiate_result"; payload?: Record<string, unknown> }
  | { event: "process_result"; payload?: Record<string, unknown> }
  | { event: "user_event"; payload?: Record<string, unknown> }
  | { event: string; payload?: Record<string, unknown> };

export interface JuspayHyperPlugin {
  preFetch(payload: Record<string, unknown>): Promise<void>;
  initiate(payload: JuspayInitiatePayload): Promise<void>;
  process(payload: JuspayProcessPayload): Promise<void>;
  terminate(): Promise<void>;
  isInitialised(): Promise<{ initialised: boolean }>;
  addListener(
    eventName: "juspayEvent",
    listener: (data: JuspayEventData) => void,
  ): Promise<PluginListenerHandle>;
  removeAllListeners(): Promise<void>;
}

export const JuspayHyper = registerPlugin<JuspayHyperPlugin>("JuspayHyper");
